import * as util from '../apiUtils';
import * as common from '../apiCommon';
import * as DocType from '../../constants/constant_doc_types';
import { MATRIX } from '../../constants/constant_item_types';

function cleanupItemUoms(arr, skipItemUom) {
  return (arr || []).reduce((acc, currItem) => {
    if (currItem.indexOf(':') > -1 && skipItemUom) {
      return acc;
    }
    const itemId = currItem.split(':')[0];
    acc.push(itemId);
    return acc;
  }, [])
}
export async function fetchItemDropdown(app, params) {
  const { searchTerm, searchParams={}, fields, id } = params;
  const dropdown_type = 'item/dropdown';
  const { excluded_items } = searchParams;

  const query = {
    id: cleanupItemUoms(id),
    dropdown_type,
    fields,
    searchTerm,
    searchParams: {
      ...searchParams,
      excluded_items: cleanupItemUoms(excluded_items, true),
    }
  };


  const result = await common.getDropdownList(app, { query });
  const items = result.map((item) => {
    if (item.item_uom) {
      item._id = item.id;
      item.id = `${item.id}:${item.item_uom.id}`;
    }
    return item;
  });
  return  items;
}

export async function fetchItemById(app, params) {
  const { id, path } = params;
  const docType = DocType.ITEM;
  const doc = await common.getDoc(app, { id, docType }, { assemble_custom_fields: true });

  return util.filterCustomFieldsByViewMode(doc, path);
}

export async function deleteItem(app, params) {
  const { id } = params;
  const docType = DocType.ITEM;
  const result = await common.deleteDoc(app, { id: id, docType });
  return result;
}

export async function validateBarcode(app, params) {
  const { barcode } = params;
  const docType = 'item/validate-barcode';
  const result = await common.queryDocs(app, docType, { barcode });
  return result;
}

export async function validateQRcode(app, params) {
  const { qrcode } = params;
  const docType = 'item/validate-qrcode';
  const result = await common.queryDocs(app, docType, { qrcode });
  return result;
}

export function saveItem(app, params) {
  const { user = {}, data } = params;

  let itemData = {
    active: data.active,
    allow_dynamic_link: data.allow_dynamic_link,
    alternate_class_id: data.alternate_class_id,
    barcodes: data.barcodes,
    brand_id: data.brand_id,
    bundle_items: data.bundle_items,
    alternate_numbers: data.alternate_numbers,
    classification_id: data.classification_id,
    consignment: data.consignment,
    correlated_items: util.toObjectIds(
      data.correlated_items,
      data.correlated_item_ids,
      'correlated_item_id',
    ),
    correlated_items_purchased: util.toObjectIds(
      data.correlated_items_purchased,
      data.correlated_items_purchased_ids,
      'correlated_item_purchased_id',
    ),
    credit_type_id: data.credit_type_id,
    custom_fields: data.custom_fields,
    description: util.toStringText(data.description),
    dimension: data.dimension,
    display_name: util.toStringText(data.display_name),
    doc_type: DocType.ITEM,
    enable_part_quantity: data.enable_part_quantity,
    excluded_locations: util.toObjectIds(
      data.excluded_locations,
      data.excluded_location_ids,
      'excluded_location_id',
    ),
    excluded_shipping_methods: util.toObjectIds(
      data.excluded_shipping_methods,
      data.excluded_shipping_method_ids,
      'shipping_method_id',
    ),
    facet_id: data.facet_id,
    group_type_id: data.group_type_id,
    image_url: util.toStringText(data.image_url),
    is_manual_promotion: data.is_manual_promotion,
    item_type: data.item_type,
    matrix_definition_id: data.matrix_definition_id,
    name: util.toStringText(data.name),
    number: util.toStringText(data.number),
    parent_id: data.parent_id,
    parent_item_type: data.parent_item_type,
    qrcodes: data.qrcodes,
    season_id: data.season_id,
    short_name: util.toStringText(data.short_name),
    substitute_items: util.toObjectIds(
      data.substitute_items,
      data.substitute_item_ids,
      'substitute_item_id',
    ),
    url_reference: util.toStringText(data.url_reference),
    safety_stock: data.safety_stock,
    weight: util.toNumber(data.weight),
    width: util.toNumber(data.width),
    height: util.toNumber(data.height),
    length: util.toNumber(data.length),
    referenced_concession: data.referenced_concession,
  };

  if ((data.parent || {}).item_type === MATRIX) {
    itemData.parent_item_type = MATRIX;
  }

  return common.saveDoc(app, {
    source: data,
    doc: itemData,
    user,
  });
}
